import { ReactElement } from 'react';
import styled from 'styled-components';

import ClickerSupportPage from '../components/ClickerSupportPage';
import { NextPageWithLayout } from '../components/layouts';
import LandingPageLayout from '../components/layouts/LandingPageLayout';

const TITLE = 'Clicker support in Curipod - Run your lesson from anywhere in the room';
const DESCRIPTION =
  'Curipod works with standard presentation clickers. Walk your room, stay close to students, and still advance every slide, activity, and poll.';

const ClickerSupport: NextPageWithLayout = () => {
  return (
    <Container>
      <LandingPageLayout
        hideBlobs={true}
        disableHeadline={true}
        title={TITLE}
        subTitle={DESCRIPTION}
      >
        <ClickerSupportPage />
      </LandingPageLayout>
    </Container>
  );
};

const Container = styled.div`
  min-height: 100vh;
`;

ClickerSupport.getLayout = function getLayout(page: ReactElement) {
  return <>{page}</>;
};

export default ClickerSupport;
